module.exports = __webpack_public_path__ + "static/media/iadt.31367748.png";